import { useCreateProductRecommendation } from '../modules/CreateProductRecommendation'
import { useHomeProductsRecommendation } from '../modules/HomeProductsRecommendation'
import { useIntegrationsRecommendation } from '../modules/IntegrationsRecommendation'

export const useOrdersEmptyStateRecommendations = () => {
  const { homeProductsRecommendation } = useHomeProductsRecommendation(true)
  const { createProductRecommendation } = useCreateProductRecommendation()
  const { integrationsRecommendation } = useIntegrationsRecommendation()

  const recommendations = [
    createProductRecommendation,
    homeProductsRecommendation,
    integrationsRecommendation,
  ]

  const isLoadingRecommendations = recommendations.some(({ isLoading }) => isLoading)

  const enabledRecommendations = (() => {
    return recommendations.filter(({ enabled }) => enabled)
  })()

  return { recommendations: !isLoadingRecommendations ? enabledRecommendations : undefined }
}
